export default "__VITE_ASSET__CbW4uSwK__"